






















































    import {Component, Vue, Prop, Watch} from "vue-property-decorator";
    import EditMeeting from "@share/meeting-form/EditMeeting.vue";
    import {Participant as ParticipantModel} from "@api/models/meetings/Participant";
    import ItemsList from "@share/common/ItemsList.vue";
    import Participant from '../Participant.vue';
    import DateTimeView from '@share/common/DateTimeView.vue';
    import {Modal} from "@common/Modal";
    import {MeetingRepository} from "@api/repositories/MeetingRepository";

    import BackButton from "@service/components/common/back-button/BackButton.vue";
    import { escapeHtml } from "@common/MessageProcessor";
    import { MeetingDataHelper } from "@share/meeting-view/helper/MeetingDataHelper";
    import { ParticipantStatuses } from "@api/enums/Meetings/ParticipantStatuses";
    import { Meeting } from "@api/models/meetings/Meeting";
    import { EventBus } from "@common/EventBus";
    import { ParticipantStatusChange } from "types/ParticipantStatusChange";
    import { UserRepository } from "@api/repositories/UserRepository";
    import { RepositoryFabric } from "@api/repositories/RepositoryFabric";

    import MessageIcon from '../../../../assets/svg/message.svg';
    import { RouteNamesEnum } from "@service/router/RouteNamesEnum";
	import { getBackend } from "@service/router/getters";

    @Component({
        name: 'MeetingsDetail',
        components: { EditMeeting, BackButton, ItemsList, Participant, DateTimeView, MessageIcon }
    })
    export default class MeetingsDetail extends Vue {

        @Prop({required: true}) id: string;

        dataHelper: MeetingDataHelper | null = null;
        isLoading = true;
        userRepository: UserRepository | null = null;
        meetingRepository: MeetingRepository;

        showEdit = false;

        linkCopied = false;

        edit() {
            this.showEdit = true;
        }

        hideEdit() {
            this.showEdit = false;
        }

        activated() {
            this.$router.push({
                hash: `#meetings_${this.id}`
            })
        }

        deactivated() {
            if(this.$route.hash.startsWith('#meetings_')) {
                this.$router.push({
                    hash: `#meetings`
                })
            }
        }

        /**
         * copy meeting link to clipboard
         */
        copyLink(event: Event) {
            event.stopPropagation();

            const { href } = this.$router.resolve({
                name: RouteNamesEnum.viewMeeting,
                params: {
                    backend: getBackend(this.$route.params.backend),
                    eventId: this.$route.params.eventId,
                    id: this.meeting?.id || ""
                }
            })

            try {
                navigator.clipboard?.writeText(`${location.origin}${href}`);
                this.linkCopied = true;

                setTimeout(() => {
                    this.linkCopied = false;
                }, 5000);
            }
            catch(e) {
                this.$store.dispatch('reportException', e, {root: true});
            }
        }

        async remove() {
            if (this.meeting?.id) {
                const modal = new Modal({
                    title: this.$t('program.cancel meeting').toString(),
                    contentText: this.$t('program.delete subtext').toString(),
                    buttons: [
                        {
                            text: this.$t('common.delete').toString(),
                            class: 'is-red',
                            returnValue: true
                        },
                        {
                            text: this.$t('common.cancel').toString(),
                            class: 'is-green is-outlined',
                            returnValue: false
                        }
                    ]
                });

                const confirmResult = await modal.showConfirm();

                if (confirmResult === true) {
                    try {
                        await this.meetingRepository.delete(this.meeting.id as string);
                        this.$store.dispatch('invites/removeMeeting', this.meeting.id);
                        this.$emit('back')
                        if(this.dataHelper?.meeting.participants) {
                            this.dataHelper.meeting.participants = []
                        }
                    }
                    catch (e) {
                        this.$store.dispatch('reportError', e);
                    }
                }
            }
        }

        get userId() {
            return this.$store.state.session.userId;
        }

        get meeting() {
            return this.dataHelper?.meeting;
        }

        get participants() {
            return this.meeting?.participants;
        }

        get description() {
            return escapeHtml(this.meeting?.description || '');
        }

        get currentUserParticipant(): ParticipantModel | null {
            return this.dataHelper?.currentUserParticipant || null;
        }

        get showAccept() {
            return !this.isOwner && [ParticipantStatuses.pending.toString(), ParticipantStatuses.declined.toString()]
                                   .indexOf((this.currentUserParticipant?.status as string || '').toLowerCase()) > -1;
        }

        get showDecline() {
            return !this.isOwner && !this.isLive && [ParticipantStatuses.pending.toString()]
                                    .indexOf((this.currentUserParticipant?.status as string || '').toLowerCase()) > -1;
        }

        get showCopy() {
            return [ParticipantStatuses.accepted.toString()].indexOf((this.currentUserParticipant?.status as string || '').toLowerCase()) > -1;
        }

        get showJoin() {
            return this.isNow;
        }

        get scrollTo() {
            return (this.meeting && this.meeting?.beginAt?.toFormat('HH:mm:00')) || '';
        }

        get isNow() {
            if (this.meeting) {
                return this.meeting?.isNow() || false;
            }
            return false;
        }

        get showConnect() {
            return this.isNow && [ParticipantStatuses.accepted.toString(), ParticipantStatuses.pending.toString()]
                            .indexOf((this.currentUserParticipant?.status as string || '').toLowerCase()) > -1;
        }

        get isOwner() {
            return this.meeting?.ownerId == this.dataHelper?.userId;
        }

        get zoom() {
            return this.dataHelper?.webinarInfo && this.dataHelper?.webinarInfo.zoom || {};
        }

        get isLiveClean() {
            return this.showConnect;
        }

        get isLive() {
            return this.isLiveClean;
        }

        get maxParticipantsNumber() {
            return 3;
        }

        get isDeleted() {
            return this.meeting?.isDeleted;
        }

        get showButtons() {
            if (this.isDeleted) {return false;}
            return true
        }

        get title() {
            if (this.meeting) {
                const title = this.meeting!.title || '';
                return title;
            }
            return '';
        }

        get meetingId() {
            return this.meeting?.id
        }

        async mounted() {
            this.dataHelper = new MeetingDataHelper(this.userId, this.$repositories);
            this.meetingRepository = this.$repositories.get(RepositoryFabric.MEETING);
            await this.initData();
            EventBus.$on('eventSaved', this.updateMeeting);
            EventBus.$on('participantStatusChanged', this.participantStatusChanged);
            EventBus.$on('program/removeMeetingById', this.removeMeetingById);
        }

        async initData() {
            this.isLoading = true;
            try {
                await this.dataHelper?.setMeeting(this.id);
                if (this.isNow && this.currentUserParticipant?.status?.toLowerCase() != ParticipantStatuses.accepted) {
                    await this.changeStatus(ParticipantStatuses.accepted);
                    await this.dataHelper?.fetchWebinarInfo();
                }

                this.isLoading = false;
                this.loaded();
            } catch (e) {
                if (e.name === 'BackendUnexpectedError') {
                    this.showRetryDialog();
                } else {
                    this.$store.dispatch('reportException', e, {root: true});
                }
            }
        }

        @Watch('id')
        async onidChanged() {
            await this.initData();
        }

        updateMeeting(meeting: Meeting) {
            this.dataHelper?.updateMeeting(meeting);
        }

        loaded() {
            this.$emit('loaded', {
                element: this.dataHelper?.meeting,
                isLive: this.isLive
            })
        }

        async accept() {
            try {
                await this.changeStatus(ParticipantStatuses.accepted);
                if (this.isNow && this.currentUserParticipant?.status?.toLowerCase() == ParticipantStatuses.accepted) {
                    await this.dataHelper?.fetchWebinarInfo();
                }
            } catch (e) {
                if (e.name === 'BackendUnexpectedError') {
                    this.showRetryDialog();
                } else {
                    this.$store.dispatch('reportException', e, {root: true});
                }
            }
        }

        async join() {
            await this.$router.push({
                name: "ViewMeeting",
                params: {
                    ...this.$route.params,
                    id: this.meetingId || ''
                }
            })

            this.$emit('close')
        }

        decline() {
            this.changeStatus(ParticipantStatuses.declined);
        }

        async changeStatus(status: ParticipantStatuses) {
            if (this.currentUserParticipant) {
                this.$store.dispatch('showSpinner');
                const previousStatus = this.currentUserParticipant.status;
                try {
                    await this.dataHelper?.changeStatus(status);
                }
                catch (e) {
                    this.$store.dispatch('reportException', e, {root: true});
                }
                this.$store.dispatch('hideSpinner');

                EventBus.$emit('participantStatusChanged', {
                    participantId: this.currentUserParticipant.id,
                    id: this.meeting?.id,
                    status: status,
                    previousStatus: previousStatus,
                    beginAt: this.meeting?.beginAt
                } as unknown as ParticipantStatusChange);

            }
        }

        async showRetryDialog() {
            const modal = new Modal({
                title: this.$t('common.liveConnectErrorConfirmTitle').toString(),
                contentText: this.$t('common.liveConnectErrorConfirmText').toString(),
                buttons: [
                    {
                        text: this.$t('common.liveConnectErrorConfirmRetryButton').toString(),
                        class: 'is-green',
                        returnValue: true
                    },
                ]
            });

            const confirmResult = await modal.showConfirm();

            if (confirmResult == 'close') {
                this.isLoading = false;
                return;
            }

            if (confirmResult === true) {
                this.initData();
            }
        }

        connect() {
            this.$emit('connect');
        }

        close() {
            this.$emit('closed');
        }

        message() {
            EventBus.$emit('messageTo', this.meeting?.ownerId);
        }

        participantStatusChanged(data: ParticipantStatusChange) {
            if (data.participantId == this.currentUserParticipant?.id) {
                this.dataHelper?.updateStatus(data.status);

                if(data.status === ParticipantStatuses.declined) {
                    this.close();
                }
            }
        }

        removeMeetingById(id: string) {
            if (this.meeting?.id == id) {
                this.$set(this.dataHelper?.meeting as Meeting, 'isDeleted', true);
            }
        }

        destroyed() {
            EventBus.$off('eventSaved', this.updateMeeting);
            EventBus.$off('participantStatusChanged', this.participantStatusChanged);
            EventBus.$off('program/removeMeetingById', this.removeMeetingById);
        }

        anotherTime() {
            if (this.meeting?.ownerId) {
                EventBus.$emit('messageTo', this.meeting?.ownerId);
            }
        }

    }

